import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RoleListState, ROLE_LIST_STATE } from './role-list.state';

export const selectRole = createFeatureSelector<RoleListState>(ROLE_LIST_STATE);

export const selectRoleList = createSelector(
  selectRole,
  (state: RoleListState) => {
    return state.dataSource;
  }
);

export const selectRoleListFilter = createSelector(
  selectRole,
  (state: RoleListState) => state.filter
);
